import { call, put } from "redux-saga/effects";
import { AuthResponse } from "reduxStore/dataTypes";
import { authFailure, authSuccess, authRequest } from "../reducers/authReducer";
import { LOGIN_TYPE, SIGN_UP_TYPE } from "../actions/authActionType";
import { login, register } from "services/apiService";
import { AxiosError } from "axios";

function* authSaga(action: any): Generator<any, void, AuthResponse | any> {
  try {
    const { type, payload } = action;
    yield put(authRequest());
    let response;
    if (type === LOGIN_TYPE) {
      response = yield call(login, payload);
    } else if (type === SIGN_UP_TYPE) {
      response = yield call(register, payload);
    }
    yield put(authSuccess(response.data));
  } catch (error: any) {
    if (error instanceof AxiosError) {
      if (error?.response?.data?.responseCode === 112405) {
        yield put(authSuccess(error?.response?.data));
      } else {
        yield put(authFailure(error.response?.data?.message || error?.message));
      }
    }
  }
}

export default authSaga;
